import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AppSettings, buildSettings } from "../hooks/settings/settings";
import { ServerVersionService } from "../services";
import { EnvVariable } from "../types";
import { AppState } from "./store";
import { SystemConfiguration } from "@nt-portal/server-sdk";

//This must stay internal and not be exported and only used here.
export const initAppSetting: AppSettings = {

    jwtClientId: '',
    production: false,
    fabrixServer: '/',
    fabrixSockets: "/",
    tcmServer: '/tcm',
    tcmSockets: '/',
    ivtServer: '/ivt',
    ivtSockets: "/",
    docChatServer: '/dca',
    docChatSockets: "/",
    aiPersona: '',
    metaDataDescription: '',
    metaDataImage: '',
    metaDataTitle: '',
    graphDataServer: '',
    graphDataSockets: "/",
    vcServer: '/vcs',
    sessionTimeout: 15,
    loginModes: [],
    activeColor: '#257c78',
    elementColor: '#5268e2',
    shadowColor: '#2a3886',
    hoverColor: '#dad69b',
    eTenderUrl: 'https://admin-uat.etenders.gov.za/',
    eTenderEnabled: false,
    theme: 'default-theme'
   
}

export interface SettingsState {
    readonly vars: EnvVariable[];
    readonly busy: boolean;
    readonly version: string;
    readonly releaseDate: string;
    readonly appSettings: AppSettings,
    readonly environment: string;
    readonly systemConfig: SystemConfiguration[],
}

export const initSettingsState: SettingsState = {
    vars: new Array<EnvVariable>(),
    environment: "",
    appSettings: {...initAppSetting},
    systemConfig: new Array<SystemConfiguration>(),
    busy: false,
    version: 'DEBUG',
    releaseDate: (new Date()).toJSON()
}


export const getVersion = createAsyncThunk(
    'settings/getVersion',
    async (arg, { getState }) => {
        let state = getState() as AppState;
        let appSettings = state.settings.appSettings;

        let service = new ServerVersionService();
        const result = await service.load(appSettings);
        return result;

    }
)


const settingsModelSlice = createSlice({
    name: 'settings',
    initialState: initSettingsState,
    reducers: {
        updateSettings(state, action) {
            state.vars = action.payload.env;
        },
        setEnvVars(state, action) {
            let vars = action.payload.env;
            let settings = buildSettings(state.appSettings, vars, []);
            state.appSettings = settings;
            state.vars = vars;
        },
        updateSystemConfiguration(state, action) {
            state.systemConfig = action.payload;
            let settings = buildSettings(state.appSettings, [], action.payload);
            state.appSettings = settings;
        }

    },
    extraReducers: (builder) => {
        
        builder.addCase(getVersion.fulfilled, (state, action) => {
            state.version = action.payload.version;
            state.releaseDate = action.payload.releaseDate;
        })
       
    }
})

export const { updateSettings, setEnvVars, updateSystemConfiguration } = settingsModelSlice.actions;
export default settingsModelSlice.reducer;
